import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MozPlacesEntity, MozPlacesFilter, MozPlacesService, Page} from './moz-places.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-moz-places',
    imports: [],
    templateUrl: './moz-places.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './moz-places.component.scss'
})
export class MozPlacesComponent implements OnInit {

  mozPlaces: Page<MozPlacesEntity> = {
    content: [],
    totalPages: 0,
    totalElements: 0,
    last: false,
    size: 0,
    number: 0,
    sort: [],
    first: false,
    numberOfElements: 0,
  };

  filters: MozPlacesFilter[] = [];

  constructor(
    private mozPlacesService: MozPlacesService,
    private notificationService: ToastrService,
  ) {
  }

  ngOnInit(): void {
    this.loadEverything();
  }


  private loadEverything() {
    this.mozPlacesService.getMozPlaces().subscribe({
      next: res => this.mozPlaces = res,
      error: err => this.notificationService.error('failed to trigger: ' + JSON.stringify(err))
    });

    this.mozPlacesService.getMozPlacesFilters().subscribe({
      next: res => this.filters = res,
      error: err => this.notificationService.error('failed to trigger: ' + JSON.stringify(err)),
    });
  }

  deleteFilter(filter: MozPlacesFilter) {
    this.mozPlacesService.deleteMozPlacesFilters(filter.id).subscribe({
      next: () => {
        this.notificationService.success('Filter deleted successfully');
        this.loadEverything();
      },
      error: (error) => {
        this.notificationService.error('Failed to delete filter');
        console.error(error);
      }
    });
  }

  urlToDomainLike(s: string): string {
    if (s == null) {
      return null;
    }
    const tokens = s.split(/[:/]/);
    if (tokens.length >= 4) {
      return `http%://${tokens[3]}%`;
    }
    return null;
  }

  addDomainFilter(mp: MozPlacesEntity) {
    const f = this.urlToDomainLike(mp.url);
    if (!f) {
      this.notificationService.error('failed to add filter, domain empty');
      return;
    }
    this.mozPlacesService.addMozPlacesFilters(f).subscribe({
      next: (filter: MozPlacesFilter) => {
        this.notificationService.success('Filter added successfully');
        this.loadEverything();
      },
      error: (error) => {
        this.notificationService.error('Failed to add filter');
        console.error(error);
      }
    });
  }

  manualAck(mp: MozPlacesEntity) {
    this.mozPlacesService.manualAck(mp.id).subscribe({
      error: (error) => {
        this.notificationService.error('Failed to perform manual ack');
        console.error(error);
      },
    });
    this.mozPlaces.content = this.mozPlaces.content.filter(it => it.id !== mp.id);
  }
}
